/** @format */

import { CLP_CONSTANTS } from '../app/app.constants';
import { IEnvironment } from '@shared/data-access/interfaces';
import { LoggerLevel } from '@shared/data-access/services';
import { chain } from '@core/chain';
import { prodEnvironmentDefaults } from '@shared/data-access/config';

export const environment: IEnvironment = {
	api: {
		spring: {
			microService: {
				...prodEnvironmentDefaults.api.spring.microService
			},
			microServiceProxy: {
				breadcrumb: {
					path: `/${CLP_CONSTANTS.appPathPrefix}/spring/msvc/breadcrumb/`,
					timeout: '15000'
				},
				category: {
					path: `/${CLP_CONSTANTS.appPathPrefix}/spring/msvc/category/`,
					timeout: '15000'
				},
				logger: {
					path: `/${CLP_CONSTANTS.appPathPrefix}/spring/msvc/logger/`,
					timeout: '15000'
				},
				seoservice: {
					path: `/${CLP_CONSTANTS.appPathPrefix}/spring/msvc/seo/`,
					timeout: '15000'
				}
			}
		},
		health: {
			AZ: 'https://prod-seo-api.iso.ap01.pcf.dcsg.com/',
			AZ3: 'https://prod-seo-api.iso.ap03.pcf.dcsg.com/',
			aksEast: 'https://seo-api.genextapps01.ue.p.aks.dcsg.com/',
			aksWest: 'https://seo-api.genextapps01.uw.p.aks.dcsg.com/'
		},
		homr: {
			...prodEnvironmentDefaults.api.homr
		},
		seo: 'https://api-search.dickssportinggoods.com/',
		seoByChain: `https://api-search.${chain.seoIdentifier}.com/`,
		brandify: {
			brandifyBaseUrl: 'https://hosted.where2getit.com/',
			proxy: {
				path: `/${CLP_CONSTANTS.appPathPrefix}/store/locator/`
			}
		},
		elastic: {
			availability: 'https://availability.dickssportinggoods.com',
			autoSuggestUrl: 'https://prod-catalog-autosuggest-api.dickssportinggoods.com/',
			searchTermUrl: 'https://prod-catalog-product-api.dickssportinggoods.com/'
		},
		esb: {
			gatewayUrl: 'https://gateway.dcsg.com/',
			gatewayUrlProxy: {
				path: `/${CLP_CONSTANTS.appPathPrefix}/esb/api/`,
				timeout: '30000'
			}
		},
		ceops: prodEnvironmentDefaults.api.ceops,
		reactMarginals: prodEnvironmentDefaults.api.reactMarginals
	},
	apiTokens: {
		brandify: {
			storeLocator: {
				dsg: '8D669860-73FB-11E8-8752-FF2F0D70A832',
				gg: 'CE23B360-C828-11E4-B146-ED9AA38844B8'
			}
		},
		esb: {
			api: '38d00cb0-6e1b-11e6-8390-8c24708cfd68',
			api2: '9b59c9e0-6710-11e7-bdcc-80098dffd0fa',
			data: '1bfc85f0-ea22-11e5-9697-8d6fc3625af1',
			identity: 'af727360-d115-11e5-ab08-be8d24eccbe9',
			myaccount: 'd0b85d50-d115-11e5-ab08-b8fc4c91c2b3',
			inventory: '1e370cd0-90fd-11e8-88c8-b1d2f2dd8b93'
		}
	},
	catOvrGrpId: {
		calia: '3074457345618270104',
		dsg: '3074457345618270104',
		gg: '10501'
	},
	customizer: 'https://dsg-responsive-v2.mycustomizer.com',
	dataFiles: {},
	defaultActiveCloudProvider: 'AZ',
	esbEnvironmentHeader: 'auxlive',
	inventory: {},
	imagePresets: false,
	logging: {
		client: {
			level: LoggerLevel.INFO
		},
		xhr: {
			level: LoggerLevel.OFF, // DO NOT TOUCH
			url: 'https://staging-log-publisher.iso.an01.pcf.dcsg.com/publish'
		}
	},
	myAccount: {},
	loyalty: {
		scorecard: 'https://myaccount-loyalitypointsservice.iso.ap01.pcf.dcsg.com/'
	},
	production: true,
	useRedis: true,
	previewLinks: false,
	searchbyTermTypeParam: '1000',
	thirdParty: {
		auth0: {
			...prodEnvironmentDefaults.thirdParty.auth0
		},
		images: {
			...prodEnvironmentDefaults.images,
			flags: {
				useProxy: false,
				useNetstorage: false
			}
		},
		scene7: {
			url: 'https://dks.scene7.com/is/image/dkscdn/',
			suffix: '$DSG_ProductCard$'
		},
		searchDex: {
			gatewayUrlProxy: {
				path: `/${CLP_CONSTANTS.appPathPrefix}/sdxincludes/api/`,
				timeout: '15000'
			},
			store: {
				dsg: {
					baseUrl: 'https://www.dickssportinggoods.com/products/includes/'
				},
				gg: {
					baseUrl: 'https://www.golfgalaxy.com/products/includes/'
				},
				calia: {
					baseUrl: 'https://www.dickssportinggoods.com/products/includes/'
				}
			}
		},
		tealium: {
			enabled: true,
			store: {
				dsg: {
					baseUrl: 'https://tag.dickssportinggoods.com/utag.js'
				},
				gg: {
					baseUrl: 'https://tag.golfgalaxy.com/utag.js'
				}
			}
		}
	},
	identityServiceKey: {
		...prodEnvironmentDefaults.identityServiceKey
	},
	feature: {
		...prodEnvironmentDefaults.feature,
		isBotCheckEnabled: {
			dsg: true,
			gg: true
		},
		isServerSideRenderStateDataEnabled: {
			dsg: true,
			gg: true
		}
	},
	killSwitch: {
		clpGoogleAdManagerEnabled: {
			dsg: true,
			gg: true
		},
		enableTooltipSurvey: {
			dsg: true,
			gg: true
		}
	},
	baseDomain: {
		...prodEnvironmentDefaults.baseDomain
	},
	platform: {
		forwardedHeadersMatchers: [/\/homr\//, /\/v1\/categories/]
	}
};
